import actions from './apartmentActions'
import mutations from './apartmentMutations'
import state from './apartmentState'
import getters from './apartmentGetters'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
